import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, Image, Text } from 'react-native';
const ImageViewer = ({ imageUrls, index = 0, onSwipeDown, renderHeader, renderFooter, backgroundColor = 'black', onClick, onChange, }) => {
    var _a;
    const [currentIndex, setCurrentIndex] = useState(index);
    const goToPrevious = () => {
        const newIndex = currentIndex > 0 ? currentIndex - 1 : imageUrls.length - 1;
        setCurrentIndex(newIndex);
        onChange === null || onChange === void 0 ? void 0 : onChange(newIndex);
    };
    const goToNext = () => {
        const newIndex = currentIndex < imageUrls.length - 1 ? currentIndex + 1 : 0;
        setCurrentIndex(newIndex);
        onChange === null || onChange === void 0 ? void 0 : onChange(newIndex);
    };
    // Keyboard event handlers
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && onSwipeDown) {
                onSwipeDown();
            }
            else if (event.key === 'ArrowLeft') {
                goToPrevious();
            }
            else if (event.key === 'ArrowRight') {
                goToNext();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onSwipeDown, goToPrevious, goToNext]);
    const handleImageClick = () => {
        if (onClick) {
            onClick();
        }
    };
    return (_jsxs(View, { style: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
        }, children: [_jsx(TouchableOpacity, { onPress: onSwipeDown, style: {
                    position: 'absolute',
                    top: 20,
                    right: 20,
                    width: 40,
                    height: 40,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                }, children: _jsx(Text, { style: { color: 'white', fontSize: 20, fontWeight: 'bold' }, children: "\u00D7" }) }), renderHeader && renderHeader(currentIndex), _jsx(View, { style: { flex: 1, width: '100%', justifyContent: 'center', alignItems: 'center' }, children: _jsx(TouchableOpacity, { onPress: handleImageClick, style: { width: '100%', height: '100%' }, children: _jsx(Image, { source: { uri: (_a = imageUrls[currentIndex]) === null || _a === void 0 ? void 0 : _a.url }, style: {
                            width: '100%',
                            height: '100%',
                            resizeMode: 'contain',
                        } }) }) }), imageUrls.length > 1 && (_jsxs(_Fragment, { children: [_jsx(TouchableOpacity, { onPress: goToPrevious, style: {
                            position: 'absolute',
                            left: 20,
                            top: '50%',
                            transform: [{ translateY: -25 }],
                            width: 50,
                            height: 50,
                            borderRadius: 25,
                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, children: _jsx(Text, { style: { color: 'white', fontSize: 24, fontWeight: 'bold' }, children: "\u2039" }) }), _jsx(TouchableOpacity, { onPress: goToNext, style: {
                            position: 'absolute',
                            right: 20,
                            top: '50%',
                            transform: [{ translateY: -25 }],
                            width: 50,
                            height: 50,
                            borderRadius: 25,
                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, children: _jsx(Text, { style: { color: 'white', fontSize: 24, fontWeight: 'bold' }, children: "\u203A" }) })] })), renderFooter && renderFooter(currentIndex), _jsx(TouchableOpacity, { onPress: onSwipeDown, style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: -1,
                } })] }));
};
export default ImageViewer;
